import type { RetryOptions } from '@shared/utils';

/**
 * @summary
<blockquote>Retry options for the database</blockquote>
 * @internal
 */
export const DB_RETRY_OPTIONS: RetryOptions = {
    maxAttempts: 3,
    initialDelay: 100,  // Start with 100ms
    maxDelay: 1000,     // Max 1 second
    retryableErrors: [
      'connection',
      'deadlock',
      'lock',
      'timeout',
      'pg_pool_timeout'
    ]
  };